import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JssService {
  
  // private apiUrl = "http://localhost:3003/api";
   private apiUrl = "https://lexipackghana.com:3003/api";

  constructor(private http: HttpClient) { }

  addJss(data:any){
    return this.http.post(this.apiUrl+'/addJss',data);
  }
  getJssList(){
    return this.http.get(this.apiUrl+'/jssList');
  }
  getJssById(id: string) {
    return this.http.get(this.apiUrl + '/GetJssById/' + id);
  }
  updateJss(id: string, data: any) {
    return this.http.put(this.apiUrl + '/UpdateJssById/' + id, data);
  }
  deleteJss(id: string) {
    return this.http.delete(this.apiUrl + '/deleteJssById/' + id);
  }
   // Method to delete multiple clients by IDs
   deleteAllJss(ids: string[]) {
    return this.http.delete<any>(this.apiUrl + '/deleteAllJss', { body: { ids } });
  }

  getJobsForClient(clientName: string) {
    return this.http.get<any[]>(`${this.apiUrl}/jobsForClient/${clientName}`);
  }
  //19nov 
  getMaterialsForClient(clientName: string, jobName: string) {
    // Encode the clientName and jobName to handle special characters
    const encodedClientName = encodeURIComponent(clientName);
    const encodedJobName = encodeURIComponent(jobName);
  
    // Make the HTTP request with the encoded parameters
    return this.http.get<any>(`${this.apiUrl}/materialsForClient/${encodedClientName}/${encodedJobName}`);
  }
 // encodeURIComponent(): This method encodes all special characters in the string, including spaces, 
 //parentheses, and symbols like %. It ensures that these characters are properly handled when included in the URL
  // getMaterialsForClient(clientName: string, jobName: string) {
  //   return this.http.get<any>(`${this.apiUrl}/materialsForClient/${clientName}/${jobName}`);
  // }
  // New method to get JSS records based on clientName and ticketno
  // getJssRecords(clientName: string, ticketno: string) {
  //   return this.http.get(`${this.apiUrl}/jss`, {
  //     params: { clientName, ticketno }
  //   });
  // }
   getJssRecords(clientName: string) {
    return this.http.get(`${this.apiUrl}/jss`, {
      params: { clientName}
    });
  }
   // New method to fetch MongoDB IDs based on jobName refNo
   getJssIdsByJobName(jobName: string) {
    return this.http.get<{ id: string }[]>(`${this.apiUrl}/jssIdOnJob`, {
      params: { jobName }
    });
  }

  getJssIdsByrefNo(refNo: string) {
    return this.http.get<{ id: string }[]>(`${this.apiUrl}/jssIdOnrefNo`, {
      params: { refNo }
    });
  }
  getJssNotificationCount() {
    return this.http.get(`${this.apiUrl}/JssNotificationCount`);
  }
}
